/**
 * EditVisitorNextDraft - Draft visitor add/edit form.
 * JUSTO-64: Same lead source and CP lead type behaviour as EditVisitorNext: CP/Referral Partner only when Lead for SM
 * selected; lead source and CP lead type (Walk-in / Tele-calling) shown as radio buttons.
 */
import React, { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useLocation } from "react-router-dom";
import strings from "translate/language";
import {
  removeVisitorMobileCheck,
  visitorFormUpdate,
  visitorMobileCheck,
  visitorDetail,
  checkReferenceNmbrExist,
} from "reduxStore/action/visitorActions";
import {
  mobileNumberValid,
  pancardValidation,
  seo,
  validateAadhaar,
  nameValid,
  handleDetailResponse,
  isEmpty,
  hideMobileNumber,
  emailAddressValid,
  handleListResponse,
} from "utils/utils";
import Breadcrumb from "component/common/breadcrumb";
import { AutocompletePlace } from "component/common/PlacesAutocomplete";
import moment from "moment";
import { universalRemoveAction } from "../../reduxStore/action/authActions";
import { VISITOR_MOBILE_CHECK } from "../../reduxStore/types";
import { getEthnicity, getMasterList } from "reduxStore/action/masterActions";
import {
  SourcingManager,
  SourcingTL,
  scm_id,
  sourcing_head_id,
  ClosingManager,
  ClosingTL,
  closing_head_id,
  SiteHead,
  ClusterHead,
  BusinessHead,
  admin_id,
  SourcingHead,
  referenceMaster,
  channelPartnerMaster,
  directWalkinMaster,
  exhibitionMaster,
  referralPartnerMaster,
  GRE, // JUSTO-64: Guest Relations Executive role ID
} from "utils/constants";
import { CpType, CONST_IDS } from "component/utilities/DemoData";
import { getAssignCPList } from "reduxStore/action/channelPartnerAction";
import { getEmployeeList } from "reduxStore/action/companyActions";
import { getAgentProperty } from "reduxStore/action/propertyActions";
import { apiCall, errorToast } from "utils/httpClient";
import apiEndPoints from "utils/apiEndPoints";
import { getUserDetailForVisitor } from "reduxStore/action/usersActions";
import { getPropertyDetail } from "reduxStore/action/propertyActions";

const EditVisitorNextDraft = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [form, setForm] = useState({});
  const [formVaild, setFormVaild] = useState(null);
  const [visitResponse, setVisitResponse] = useState({});
  const [visitModule, setVisitModule] = useState(false);
  const [leadSourceType, setleadSourceType] = useState([]);
  const [allLeadSource, setAllLeadSource] = useState([]);
  const [agentList, setAgentList] = useState([]);
  const [viewDetails, setViewDetails] = useState({});
  const [dropdownAgentList, setDropdownAgentList] = useState([]);
  const [companyList, setCompanyList] = useState([]);
  const [employeeList, setEmployeeList] = useState([]);
  const [allProperty, setAllProperty] = useState([]);
  const [sourcingPropertyList, setSourcingPropertyList] = useState([]);
  const [emptyArray, setEmptyArray] = useState([]);
  const [smData, setSmData] = useState([]);
  const [selectedRoleId, setSelectedRoleId] = useState(null);
  const [selectedSMRoleId, setSelectedSMRoleId] = useState(null);
  const [cmData, setCmData] = useState([]);
  const [ethnicityList, setEthnicityList] = useState([]);

  const location = useLocation();
  const [leadId, setLeadId] = useState(null);

  useEffect(() => {
    // Create a URLSearchParams instance from the query string
    const queryParams = new URLSearchParams(location.search);
    const leadIdFromQuery = queryParams.get("lead_id"); // Get the 'leadid' query parameter

    setLeadId(leadIdFromQuery);
  }, [location.search]);

  const navigatpage = async (navname) => {
    navigate(navname);
  };

  const leadSourceSelector = useSelector((state) => state.masterData);
  const visitorDataSelector = useSelector((state) => state.visitorForm);
  const employeeData = useSelector((state) => state.companydata) || {};
  const cpUserList = useSelector((state) => state.channelPartner) || {};
  const { response: res } = useSelector((state) => state.login);
  const visitorDetailSelector = useSelector((state) => state.visitor);
  const userData = useSelector((state) => state.userData);
  const userDetails = userData?.userDetails?.data;

  const propertyData = useSelector((state) => state.propertyData);

  const getPropertyDetailSelector = useSelector((state) => state.propertyData);
  const ethnicitySelector = useSelector((state) => state.ethnicitys);

  useEffect(() => {
    if (leadId) {
      if (form.property_id) {
        dispatch(getPropertyDetail({ property_id: form.property_id }));
      }
    }
  }, [dispatch, form.property_id, leadId]);

  useEffect(() => {
    if (leadId) {
      if (getPropertyDetailSelector.detail) {
        const { response } = getPropertyDetailSelector;
        if (response?.status === 200) {
          setViewDetails(handleDetailResponse(response?.data));
        } else {
          setViewDetails({});
        }
      }
    }
  }, [getPropertyDetailSelector]);

  useEffect(() => {
    if (res?.data?._id && !userData?.userDetails) {
      // Make sure the user data is not already available
      dispatch(getUserDetailForVisitor({ user_id: res?.data?._id }));
    }
  }, [dispatch, res?.data?._id, userData?.userDetails]); // Depend on userId and userData

  const visitorMobileCheckNumber = useSelector(
    (state) => state.visitorMobileCheck
  );

  useEffect(() => {
    if (visitorDataSelector.update) {
      setForm({ ...visitorDataSelector.response });
    }
  }, [visitorDataSelector]);

  useEffect(() => {
    if (leadId) {
      dispatch(visitorDetail({ lead_id: leadId }));
    }
  }, [dispatch, leadId]);

  let role_id;
  let user_id;

  const isCreated = useSelector((state) => {
    const { response } = state.login;
    user_id = response?.data?.user_id;
    role_id = response?.data.role_id;
    return form?.create_by === handleDetailResponse(response.data)._id
      ? true
      : false;
  });

  // JUSTO-64: GRE treated as CM team for lead-source / "Lead for SM" behaviour (allocates to CM/SCM only)
  const Cmteam =
    ClosingTL === role_id ||
    ClosingManager === role_id ||
    closing_head_id === role_id ||
    GRE === role_id;

  const SMteam =
    SourcingTL === role_id ||
    SourcingManager === role_id ||
    sourcing_head_id === role_id;

  const mixTeam =
    scm_id === role_id ||
    SiteHead === role_id ||
    ClusterHead === role_id ||
    BusinessHead === role_id ||
    admin_id === role_id;

  const ClsManager = ClosingManager == role_id;

  // const leadsourcefilteredData = leadSourceSelector?.response?.data.filter(
  //   (obj) =>
  //     Cmteam
  //       ? obj.title !== "Channel Partner" && obj._id !== referralPartnerMaster
  //       : SMteam
  //       ? obj.title === "Channel Partner"
  //       : obj.title !== ""
  // );

  useEffect(() => {
    if (visitorMobileCheckNumber?.response?.status) {
      dispatch(removeVisitorMobileCheck());
      if (visitorMobileCheckNumber?.response?.status === 200) {
        setForm({ ...form, visit_confirmation_status: 1 });
      } else {
        if (
          visitorMobileCheckNumber?.response?.status === 201 ||
          visitorMobileCheckNumber?.response?.status === 202
        ) {
          setVisitModule(true);
          setVisitResponse(visitorMobileCheckNumber?.response);
          dispatch(universalRemoveAction(VISITOR_MOBILE_CHECK));
        }
      }
    }
  }, [dispatch, form, visitorMobileCheckNumber]);

  useEffect(() => {
    if (visitorMobileCheckNumber?.response1?.status === 200) {
      // Update the form with the referrer name and email from the API response
      setForm((prevForm) => ({
        ...prevForm,
        referrer_name: visitorMobileCheckNumber?.response1?.data,
        referrer_email: visitorMobileCheckNumber?.response1?.referrer_email,
      }));
    }
    //  else {
    //   // If the response is not valid, clear the name and email
    //   setForm((prevForm) => ({
    //     ...prevForm,
    //     referrer_name: "",
    //     referrer_email: "",
    //   }));
    // }
  }, [visitorMobileCheckNumber?.response1]);

  useEffect(() => {
    if (ethnicitySelector.response) {
      const { response } = ethnicitySelector;
      if (response?.status === 200) {
        const filteredEthnicitys = response.data;
        setEthnicityList(filteredEthnicitys);
      } else {
        setEthnicityList([]);
      }
    }
  }, [ethnicitySelector, viewDetails]);

  useEffect(() => {
    dispatch(getMasterList({ type: 13 }));
    dispatch(getEthnicity({ type: 15 }));
  }, [dispatch]);

  useEffect(() => {
    dispatch(getAssignCPList({ user_id: user_id }));
  }, []);

  useEffect(() => {
    if (cpUserList?.response?.status === 200 && !form.isSousingManagerLead) {
      setAgentList(cpUserList?.response?.data);
    } else {
      setAgentList([]);
    }
  }, [cpUserList, form.isSousingManagerLead]);

  useEffect(() => {
    if (employeeData?.emplist) {
      setEmployeeList(employeeData?.response);
    } else {
      setEmployeeList([]);
    }
  }, [employeeData]);

  useEffect(() => {
    if (!leadId) {
      dispatch(getAgentProperty());
    }
  }, [dispatch, leadId]);

  useEffect(() => {
    if (visitorDetailSelector?.detail) {
      const { response } = visitorDetailSelector;

      // Check if the response is successful
      if (response?.status === 200) {
        const result = handleDetailResponse(response?.data);
        // Only update form if there is a change in the data
        setForm((prevForm) => {
          // Compare if the form data has changed to avoid unnecessary re-renders
          if (
            prevForm.first_name !== result?.customer_detail?.first_name ||
            prevForm.last_name !== result?.customer_detail?.last_name ||
            prevForm.mobile !== result?.customer_detail?.mobile
            // add more comparisons as necessary for other fields
          ) {
            return {
              ...prevForm,
              lead_id: leadId,
              create_by: result?.create_by,
              property_title: result?.property_title,
              property_id: result?.property_id,
              lead_source: result?.lead_source_id,
              cp_emp_id: result?.cp_emp_id,
              for_sm_id: result?.for_sm_id,
              cp_id: result?.cp_id,
              configuration: result?.configuration,
              configuration_id: result?.configuration_id,
              expected_possession_date: result?.expected_possession_date
                ? moment(result?.expected_possession_date).format("YYYY-MM-DD")
                : null,
              preferred_bank: result?.customer_detail?.preferred_bank,
              property_type: result?.customer_detail?.property_type,
              areain_sqlft: result?.areain_sqlft,
              min_budget: result?.min_budget,
              min_emi_budget: result?.min_emi_budget,
              max_budget: result?.max_budget,
              max_emi_budget: result?.max_emi_budget,
              min_budget_type: result?.min_budget_type,
              min_emi_budget_type: result?.min_emi_budget_type,
              max_budget_type: result?.max_budget_type,
              max_emi_budget_type: result?.max_emi_budget_type,
              funding_type: result?.funding_type,
              purpose: result?.purpose,
              first_name: result?.customer_detail?.first_name,
              last_name: result?.customer_detail?.last_name,
              marital_status: result?.customer_detail?.marital_status,
              adhar_no: result?.customer_detail?.adhar_no,
              pancard_no: result?.customer_detail?.pancard_no,
              current_stay: result?.customer_detail?.current_stay,
              no_of_family_member: result?.customer_detail?.no_of_family_member,
              gender: result?.customer_detail?.gender,
              birth_date: result?.customer_detail?.birth_date
                ? moment(result?.customer_detail?.birth_date).format(
                    "YYYY-MM-DD"
                  )
                : null,
              mobile: result?.customer_detail?.mobile,
              whatsapp_no: result?.customer_detail?.whatsapp_no,
              email: result?.customer_detail?.email,
              location: result?.customer_detail?.location,
              locality: result?.customer_detail?.locality,
              occupation: result?.customer_detail?.occupation,
              desigantion: result?.customer_detail?.desigantion,
              coumpany_name: result?.customer_detail?.coumpany_name,
              office_address: result?.customer_detail?.office_address,
              referrer_contact: result?.referrer_contact,
              referrer_name: result?.referrer_name,
              referrer_email: result?.referrer_email,
              cp_lead_type: result?.cp_lead_type,
              referrel_partner: result?.referrel_partner,
              isSousingManagerLead: !!result?.for_sm_id,
              draft: true,
              ethnicity: result?.customer_detail?.ethnicity,
              ethnicity_id: result?.customer_detail?.ethnicity_id,
              visit_with: result?.customer_detail?.visit_with,
              expected_possession_period: result?.expected_possession_period,
              budget_amount: result?.budget_amount,
              lead_priority: result?.lead_priority,
              qualified: result?.qualified,
            };
          }
          return prevForm; // Don't update if there is no change
        });
      }
    }
  }, [visitorDetailSelector, form, leadId]);

  const handleRightButton = () => {
    if (visitResponse?.status === 201) {
      setForm({ ...form, visit_confirmation_status: 1 });
    } else {
      if (visitResponse?.status === 202) {
        setForm({ ...form, visit_confirmation_status: 1 });
      }
    }
  };

  useEffect(() => {
    dispatch(getMasterList({ type: 13 }));
  }, [dispatch]);

  /**
   * JUSTO-64: Lead source filter - Channel Partner and Referral Partner only when Lead for Sourcing Manager
   * is selected (form.for_sm_id or form.isSousingManagerLead). Aligned with EditVisitorNext behaviour.
   */
  useEffect(() => {
    if (leadSourceSelector.response) {
      const { response } = leadSourceSelector;
      if (response?.status === 200) {
        let filteredData = response.data;
        setAllLeadSource(handleListResponse(filteredData));
        const effectiveRole = selectedRoleId || res?.data?.role_id;
        if (form.referrel_partner === 1) {
          form.lead_source = referralPartnerMaster;
        }
        if (
          userDetails?.rom &&
          [SourcingHead, SourcingManager, SourcingTL].includes(effectiveRole)
        ) {
          // For SourcingManager and SourcingTL, only Channel Partner and Reference should be included
          filteredData = filteredData.filter((item) =>
            [
              channelPartnerMaster,
              directWalkinMaster,
              exhibitionMaster,
              referralPartnerMaster,
              referenceMaster,
            ].includes(item._id)
          );
        } else if (
          [SourcingHead, SourcingManager, SourcingTL].includes(effectiveRole)
        ) {
          // For SourcingManager and SourcingTL, only Channel Partner and Reference should be included
          filteredData = filteredData.filter((item) =>
            [channelPartnerMaster, referralPartnerMaster].includes(item._id)
          );
        } else if (
          [ClosingManager, ClosingTL, closing_head_id].includes(effectiveRole)
        ) {
          // For ClosingManager and ClosingTL, show Channel Partner and Referral Partner only when Lead for Sourcing Manager is selected
          if (
            form.for_sm_id ||
            form.isSousingManagerLead ||
            form.lead_source == CONST_IDS.cp_lead_source_id ||
            form.lead_source == referralPartnerMaster
          ) {
            filteredData = filteredData.filter((item) =>
              [channelPartnerMaster, referralPartnerMaster].includes(item._id)
            );
          } else {
            filteredData = filteredData.filter(
              (item) =>
                ![channelPartnerMaster, referralPartnerMaster].includes(
                  item._id
                )
            );
          }
        } else {
          // JUSTO-64: For other roles (e.g. GRE): show Channel Partner and Referral Partner only when Lead for Sourcing Manager is selected
          if (
            form.for_sm_id ||
            form.lead_source == CONST_IDS.cp_lead_source_id ||
            form.lead_source == referralPartnerMaster
          ) {
            // keep full list when lead for SM selected or already CP/Ref
          } else {
            filteredData = filteredData.filter(
              (item) =>
                ![channelPartnerMaster, referralPartnerMaster].includes(
                  item._id
                )
            );
          }
        }
        setleadSourceType(handleListResponse(filteredData));
      } else {
        setleadSourceType([]);
      }
    }
  }, [
    leadSourceSelector,
    res?.data?.role_id,
    userDetails?.rom,
    selectedRoleId,
    form,
  ]);

  const handleInputField = (e) => {
    if (e.target.name === "adhar_no") {
      let formattedText = e.target.value.split(" ").join("");
      if (formattedText.length > 0) {
        formattedText = formattedText
          .match(new RegExp(".{1,4}", "g"))
          .join(" ");
      }
      // props.disableSpecialCharacters === true &&
      // if (Regexs.alphaNumeric.test(val) === true) {
      //   props.onChangeText(formattedText);
      // }

      // Update the form state
      const nextFormState = {
        ...form,
        [e.target.name]: formattedText,
      };
      e.target.value = formattedText;
      setForm(nextFormState);
    } else {
      const nextFormState = {
        ...form,
        [e.target.name]: e.target.value,
      };
      setForm(nextFormState);
    }

    if (e.target.name === "lead_source") {
      let referrel_partner = null; // default value

      if (e.target.value === CONST_IDS?.ref_lead_source_id) {
        referrel_partner = 2;
      } else if (e.target.value === referralPartnerMaster) {
        referrel_partner = 1;
      }

      setForm((prevForm) => ({
        ...prevForm,
        cp_type: e.target.value === CONST_IDS?.cp_lead_source_id ? 2 : "",
        referrel_partner: referrel_partner,
        cp_id: null,
        cp_emp_id: "",
        referrer_name: "",
        referrer_email: "",
        referrer_contact: "",
        property_id: form.property_id || "",
        property_title: form.property_title || "",
        cp_lead_type: "",
        [e.target.name]: e.target.value,
      }));
    }

    if (e.target.name === "referrer_contact") {
      // If value has 10 digits, call the API to check referrer number
      if (e.target.value.length === 10) {
        dispatch(checkReferenceNmbrExist({ referrer_contact: e.target.value }));
      } else {
        // If the contact number is not valid, clear name and email
        setForm((prevForm) => ({
          ...prevForm,
          referrer_name: "",
          referrer_email: "",
          [e.target.name]: e.target.value, // Keep the current input value in the form
        }));
      }
    } else {
      // For other fields, simply update the form state
      setForm((prevForm) => ({
        ...prevForm,
        [e.target.name]: e.target.value,
      }));
    }
  };

  const handleInputField2 = (e) => {
    if (e.target.name === "adhar_no") {
      let formattedText = e.target.value.split(" ").join("");
      if (formattedText.length > 0) {
        formattedText = formattedText
          .match(new RegExp(".{1,4}", "g"))
          .join(" ");
      }
      // props.disableSpecialCharacters === true &&
      // if (Regexs.alphaNumeric.test(val) === true) {
      //   props.onChangeText(formattedText);
      // }

      // Update the form state
      const nextFormState = {
        ...form,
        [e.target.name]: formattedText,
      };
      e.target.value = formattedText;
      setForm(nextFormState);
    } else {
      const nextFormState = {
        ...form,
        [e.target.name]: e.target.value,
      };
      setForm(nextFormState);
    }

    if (e.target.name === "lead_source") {
      let referrel_partner = null; // default value

      if (e.target.value === CONST_IDS?.ref_lead_source_id) {
        referrel_partner = 2;
      } else if (e.target.value === referralPartnerMaster) {
        referrel_partner = 1;
      }

      setForm((prevForm) => ({
        ...prevForm,
        cp_type: e.target.value === CONST_IDS?.cp_lead_source_id ? 2 : "",
        referrel_partner: referrel_partner,
        cp_id: null,
        cp_emp_id: "",
        referrer_name: "",
        referrer_email: "",
        referrer_contact: "",
        // property_id: "",
        // property_title: "",
        cp_lead_type: "",
        [e.target.name]: e.target.value,
      }));
    }

    if (e.target.name === "referrer_contact") {
      // If value has 10 digits, call the API to check referrer number
      if (e.target.value.length === 10) {
        dispatch(checkReferenceNmbrExist({ referrer_contact: e.target.value }));
      } else {
        // If the contact number is not valid, clear name and email
        setForm((prevForm) => ({
          ...prevForm,
          referrer_name: "",
          referrer_email: "",
          [e.target.name]: e.target.value, // Keep the current input value in the form
        }));
      }
    } else {
      // For other fields, simply update the form state
      setForm((prevForm) => ({
        ...prevForm,
        [e.target.name]: e.target.value,
      }));
    }
  };

  const handleInputField1 = (e) => {
    const nextFormState = {
      ...form,
      [e.target.name]:
        e.target.name === "adhar_no"
          ? e.target.value
              .replace(/\D/g, "") // Remove non-digits
              .slice(0, 12) // Limit to 16 digits
              .split(/(\d{4})/) // Split into groups of 4 digits
              .filter(Boolean) // Remove empty strings
              .join(" ")
          : e.target.value,
    };
    SMteam
      ? setForm({ ...nextFormState, lead_source: form?.lead_source })
      : setForm(nextFormState);

    // form.cp_id !== "" ? handleGetProperty(form.cp_id) :
    // handleGetProperty(form?.cp_id);
  };

  const handleInputField3 = (e) => {
    const nextFormState = {
      ...form,
      [e.target.name]:
        e.target.name === "adhar_no"
          ? e.target.value
              .replace(/\D/g, "") // Remove non-digits
              .slice(0, 12) // Limit to 16 digits
              .split(/(\d{4})/) // Split into groups of 4 digits
              .filter(Boolean) // Remove empty strings
              .join(" ")
          : e.target.value,
    };
    setForm(nextFormState);
    // setForm({
    //   ...form,
    //   cp_id: e.target.value,
    // });
    dispatch(getEmployeeList({ agency_id: e.target.value }));
    // callEmploy()
  };

  useEffect(() => {
    form.cp_id !== ""
      ? handleGetProperty(form.cp_id)
      : handleGetProperty(form?.cp_id);
  }, [form?.cp_id]);

  useEffect(() => {
    if (propertyData?.response) {
      const { response } = propertyData;
      if (response?.status === 200 && response?.data?.length > 0) {
        setSourcingPropertyList(
          response?.data?.filter((el) => el?.status === true)
        );
      } else {
        setSourcingPropertyList([]);
      }
    }
  }, [propertyData]);

  const handleGetProperty = async (id) => {
    const params = {
      cp_id: id,
    };
    if (!leadId) {
      const res = await apiCall(
        "post",
        apiEndPoints.GET_CP_PROPERTY_FOR_SM,
        params
      );
      const response = res?.data;

      if (response?.status === 200) {
        if (response?.data?.length > 0) {
          const list = sourcingPropertyList?.filter((o1) =>
            response?.data?.some((o2) => o1?.property_id === o2?.property_id)
          );
          setAllProperty(list);
        } else {
          setAllProperty([]);
        }
      } else {
        setAllProperty([]);
      }
    }
  };

  useEffect(() => {
    // Automatically set cp_type to 2 if the lead_source matches cp_lead_source_id
    if (form.lead_source === CONST_IDS?.cp_lead_source_id) {
      setForm((prevForm) => ({
        ...prevForm,
        cp_type: "2", // Set cp_type to 2
      }));
    }
  }, [form.lead_source]);

  const callEmploy = useCallback(() => {
    dispatch(getEmployeeList({ agency_id: form?.cp_id }));
  }, [form?.cp_id]);

  const handleInputArea = (e) => {
    const nextFormState = {
      ...form,
      location: e,
      latitude: "",
      longitude: "",
    };
    setForm(nextFormState);
  };

  useEffect(() => {
    if (leadId) {
      const channelPartnerProperty = viewDetails.property_allocateds?.find(
        (item) => item.role_title === "Channel Partner"
      );

      // Step 2: Get the user IDs associated with the "Channel Partner" role
      const channelPartnerUserIds = channelPartnerProperty
        ? channelPartnerProperty.users.map((user) => user._id)
        : [];

      // Step 3: Filter the agentList to find agents whose IDs match the user IDs
      const filteredAgents = agentList?.filter((agent) =>
        channelPartnerUserIds.includes(agent._id)
      );
      setCompanyList(filteredAgents);

      if (form.isSousingManagerLead) {
        getPropertyBasedSMRoleDetails(form.property_id);
        getSmRolesUnderCpData(form.for_sm_id, form.property_id);
      }
    } else {
      if (form.isSousingManagerLead) {
        getPropertyBasedSMRoleDetails(form.property_id);
        getSmRolesUnderCpData(form.for_sm_id, form.property_id);
      } else {
        const tempArr = agentList?.filter((el) => el?.cp_type === 2);
        setCompanyList(tempArr);
      }
    }
  }, [agentList, leadId, viewDetails.property_allocateds]);

  useEffect(() => {
    if (ClosingManager == role_id && form.property_id) {
      getPropertyBasedCMRoleDetails(form.property_id);
    }
  }, [form.property_id]);

  const handleCpNameDropdownPress = () => {
    const tempArr = agentList?.filter(
      (el) =>
        (el?.cp_type !== 2 || el?.cp_type === undefined) &&
        el?.active_status === true
    );
    setDropdownAgentList(tempArr);
  };

  const handleEmployeeDropdownPress = () => {
    if (employeeData.emplist) {
      setEmployeeList(employeeData?.response);
    } else {
      setEmployeeList([]);
    }
  };

  const onSelect = (latLng, location) => {
    const nextFormState = {
      ...form,
      location: location,
      latitude: latLng.lat,
      longitude: latLng.lng,
    };
    setForm(nextFormState);
  };

  const handleNext = () => {
    if (!handleValid()) {
      if (form?.lead_source === referralPartnerMaster) {
        form.lead_source = referenceMaster;
      }
      dispatch(visitorFormUpdate(form));
      dispatch(getPropertyDetail({ property_id: form.property_id }));
      let leadID = form?.lead_id ? "?lead_id=" + form?.lead_id : "";
      navigatpage("/visitor_form_third" + leadID);
    }
  };
  const handleValid = () => {
    let err = {};
    let formError = false;
    if (!form.first_name) {
      formError = true;
      err["first_name"] = strings.firstName_Err;
    } else if (!nameValid(form.first_name)) {
      formError = true;
      err["first_name"] = strings.nameValidErr;
    }
    if (!form.mobile) {
      formError = true;
      err["mobile"] = strings.mobileErr;
    } else if (!mobileNumberValid(form.mobile)) {
      formError = true;
      err["mobile"] = strings.mobileValidErr;
    }
    if (!form.lead_source) {
      formError = true;
      err["lead_source"] = strings.leadSourceErr;
    }
    if (form.isSousingManagerLead) {
      if (!form.for_sm_id) {
        formError = true;
        err["for_sm_id"] = strings.forSmIdErr;
      }
    }
    if (form.lead_source === CONST_IDS?.cp_lead_source_id) {
      if (!form.cp_type && SMteam) {
        formError = true;
        err["cp_type"] = strings.chanelPartnerType;
      }
      if (!form.cp_id && SMteam) {
        formError = true;
        err["cp_id"] = strings.chanelPartnerRequired;
      }
      if (!form.cp_type) {
        formError = true;
        err["cp_type"] = strings.chanelPartnerType;
      }
      if (!form.cp_id) {
        formError = true;
        err["cp_id"] = strings.chanelPartnerRequired;
      }
      if (!form.cp_lead_type) {
        formError = true;
        err["cp_lead_type"] = strings.chanelPartnerType;
      }
    }
    if (
      !form.referrer_contact &&
      (form.lead_source === CONST_IDS?.ref_lead_source_id ||
        form.lead_source === referralPartnerMaster)
    ) {
      formError = true;
      err["referrer_contact"] = strings.referrerRequired;
    }
    if (
      !form.referrer_name &&
      (form.lead_source === CONST_IDS?.ref_lead_source_id ||
        form.lead_source === referralPartnerMaster)
    ) {
      formError = true;
      err["referrer_name"] = strings.referrerRequired;
    }
    if (
      form.lead_source === CONST_IDS?.ref_lead_source_id ||
      form.lead_source === referralPartnerMaster
    ) {
      if (!mobileNumberValid(form.referrer_contact)) {
        formError = true;
        err["referrer_contact"] = strings.mobileValidErr;
      }
    }
    if (!form.property_id) {
      formError = true;
      err["property_id"] = strings.propertyRequire;
    }
    if (!form.gender) {
      formError = true;
      err["gender"] = strings.genderErr;
    }
    if (form.email && !emailAddressValid(form.email)) {
      formError = true;
      err["email"] = strings.emailValidationErr;
    }
    if (form.referrer_email && !emailAddressValid(form.referrer_email)) {
      formError = true;
      err["referrer_email"] = strings.emailValidationErr;
    }
    if (form.whatsapp_no && !mobileNumberValid(form.whatsapp_no)) {
      formError = true;
      err["whatsapp_no"] = strings.mobileValidErr;
    }
    if (form.adhar_no && !validateAadhaar(form.adhar_no)) {
      formError = true;
      err["adhar_no"] = strings.validAadhar_Err;
    }
    if (form.pancard_no && !pancardValidation(form.pancard_no)) {
      formError = true;
      err["pancard_no"] = strings.validPancard_Err;
    }
    if (!form?.lead_id) {
      if (form.mobile && !form.visit_confirmation_status) {
        formError = true;
        err["visit_confirmation_status"] = strings.checkMobileNumber;
      }
    }

    setFormVaild(err);

    return formError;
  };

  setTimeout(() => {
    setFormVaild();
  }, 20000); // Delay of 500ms (can be ad

  useEffect(() => {
    seo({
      title: "Visitor Form",
      metaDescription: "Visitor_form",
      canonicalLink: window.location.href,
    });
  }, []);

  // useEffect(() => {
  //   if (leadId) {
  //     if (form.isSousingManagerLead) {
  //       getPropertyBasedSMRoleDetails(form.property_id);
  //       getSmRolesUnderCpData(form.for_sm_id, form.property_id);
  //     }
  //   }
  // }, [leadId, form.isSousingManagerLead]);

  const checkMobileExistWithSameProperty = async (propertyId) => {
    let params = {
      mobile: form?.mobile,
      property_id: propertyId,
    };

    try {
      const res = await apiCall(
        "post",
        apiEndPoints.CHECK_VISIT_MOB_AVAILABLE,
        params
      );

      if (res?.data?.status === 200) {
        return true;
      } else if (res?.data?.status === 201) {
        errorToast(res?.data?.message);
        // setOkIsVisible(true);
        setTimeout(() => {
          setForm({
            ...form,
            property_id: "",
            property_type_title: "",
            property_title: "",
          });
        }, 500);
        return false;
      }
    } catch (e) {
      console.log("error", e);
    }
  };

  const getPropertyBasedSMRoleDetails = async (propertyId) => {
    let params = {
      property_id: propertyId,
    };
    const res = await apiCall(
      "post",
      apiEndPoints.GET_PROPERTY_BASED_SM,
      params
    );
    if (res?.data?.status === 200) {
      setSmData(res.data.data);
      if (res.data.data.length > 0) {
        setSelectedRoleId(SourcingManager);
      }
    }
  };

  // JUSTO-64: GRE allocation – fetch CMs + SCM for property; used by Allocate CM modal
  const getPropertyBasedCMRoleDetails = async (propertyId) => {
    let params = {
      property_id: propertyId,
    };
    const res = await apiCall(
      "post",
      apiEndPoints.GET_PROPERTY_BASED_CM,
      params
    );
    if (res?.data?.status === 200) {
      setCmData(res.data.data);
    } else {
      setCmData([]);
    }
  };

  const getSmRolesUnderCpData = async (sm_id, property_Id) => {
    let params = {
      sm_id: sm_id,
      property_id: form.property_id || property_Id,
    };

    try {
      const res = await apiCall("post", apiEndPoints.CP_UNDER_PROPERTY, params);
      if (res?.data?.status === 200) {
        setCompanyList(res?.data?.data);
      } else {
        setCompanyList([]);
      }
    } catch (error) {
      console.error("Error making POST request:", error);
    }
  };

  const handleLeadTypeChange = (e) => {
    const { value } = e.target;

    // Map the selected option to the corresponding numeric value
    setForm({
      ...form,
      cp_lead_type: value,
    });
  };

  const getLeadSource = () => {
    if (!form.lead_source) {
      return strings.selectLeadSource;
    }
    if (form.lead_source == referenceMaster && form.referrel_partner == 1) {
      return referralPartnerMaster;
    }
    return form.lead_source;
  };

  return (
    <div className="page-body">
      <Breadcrumb
        title={strings.updatedraftvisitor}
        url={"/visitor"}
        parentListing={strings.visitorList}
        titleactive={strings.updateDraftVisitor}
        isBackBtn={true}
      />
      {/*add_module_start */}
      {visitModule ? (
        <div
          className="modal show"
          tabIndex="-1"
          style={{
            display: "block",
          }}
          role="dialog"
          aria-labelledby="exampleModalLabel"
          aria-hidden="true"
        >
          <div className="modal-dialog modal-dialog-centered" role="document">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title" id="exampleModalLabel">
                  {strings.conformation}
                </h5>
                <button
                  className="close"
                  type="button"
                  data-dismiss="modal"
                  aria-label="Close"
                  onClick={() => {
                    setVisitModule(false);
                    setForm({ ...form, visit_confirmation_status: "" });
                  }}
                >
                  <span aria-hidden="true">×</span>
                </button>
              </div>
              <div className="modal-body">
                <div className="text-center">
                  <h6>
                    {visitResponse?.message === "" ||
                    visitResponse?.message === undefined ||
                    visitResponse?.message === null
                      ? strings.notavailable
                      : visitResponse?.message}
                  </h6>
                </div>
              </div>
              <div className="modal-footer justify-content-center">
                <button
                  className="btn btn-success mr-5"
                  type="button"
                  onClick={() => {
                    setVisitModule(false);
                    // handleLeftButton();
                  }}
                  data-dismiss="modal"
                >
                  {visitResponse?.status === 201
                    ? strings.no
                    : visitResponse?.status === 202
                    ? strings.useOldData
                    : strings.notavailable}
                </button>
                <button
                  className="btn btn-primary"
                  type="button"
                  onClick={() => {
                    setVisitModule(false);
                    handleRightButton();
                  }}
                  data-dismiss="modal"
                >
                  {visitResponse?.status === 201
                    ? strings.yes
                    : visitResponse?.status === 202
                    ? strings.createNew
                    : strings.notavailable}
                </button>
              </div>
            </div>
          </div>
        </div>
      ) : null}

      {/* add_module_end */}
      <div className="container-fluid">
        <div className="row ">
          <div className="col-sm-12 ">
            <div className="card">
              <div className="card-header pb-0">
                <h5>{strings.updatedraftvisitor}</h5>
              </div>
              <form className="form theme-form">
                <div className="card-body">
                  <div className="row ">
                    <div className="col-md-8">
                      <div className="mb-3">
                        <label htmlFor="exampleFormControlFirstName">
                          {strings.visitorFullName}
                          <span className="required-field"></span>
                        </label>
                        <input
                          className="form-control"
                          id="exampleFormControlFirstName"
                          type="text"
                          name="first_name"
                          value={form?.first_name}
                          placeholder={strings.visitorFullName}
                          onChange={handleInputField}
                          autoComplete="off"
                        />
                        {formVaild?.first_name && (
                          <span style={{ color: "red" }}>
                            {formVaild?.first_name}
                          </span>
                        )}
                      </div>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-md-8">
                      <div className="mb-3">
                        <label htmlFor="exampleInputMobileNo">
                          {strings.mobileNo}
                          <span className="required-field"></span>
                        </label>
                        <input
                          className="form-control"
                          id="exampleInputMobileNo"
                          readOnly={
                            isCreated ? false : form?.lead_id ? true : false
                          }
                          type="text"
                          maxLength={10}
                          name="mobile"
                          value={
                            form?.lead_id
                              ? isCreated
                                ? form?.mobile
                                : form?.mobile
                                ? hideMobileNumber(form?.mobile)
                                : ""
                              : form?.mobile
                          }
                          placeholder={strings.mobileNo}
                          onChange={handleInputField}
                          autoComplete="off"
                          onKeyPress={(event) => {
                            if (/^[a-z]+$/.test(event.key)) {
                              event.preventDefault();
                            }
                          }}
                          onFocus={() => setVisitResponse({})}
                          onBlur={() => {
                            if (!form?.lead_id && form?.mobile?.length === 10) {
                              dispatch(
                                visitorMobileCheck({
                                  mobile: form.mobile,
                                  property_id: form.property_id,
                                  visitor_name: form.first_name,
                                  cp_id: form.cp_id,
                                })
                              );
                            }
                          }}
                        />
                        {formVaild?.mobile && (
                          <span style={{ color: "red" }}>
                            {formVaild?.mobile}
                          </span>
                        )}
                        {formVaild?.visit_confirmation_status && (
                          <span style={{ color: "red" }}>
                            {formVaild?.visit_confirmation_status}
                          </span>
                        )}
                      </div>
                    </div>
                  </div>

                  {ClsManager && (
                    <div className="row">
                      <div className="col-md-8">
                        <div className="mb-3">
                          <label className="form-label fw-bold">
                            {strings.assignToNewClosingManager}
                          </label>
                          <select
                            className="form-control"
                            name="sourcing_manager_id"
                            value={form.new_cm_id}
                            onChange={(e) => {
                              const selectedId = e.target.value;
                              setForm({
                                ...form,
                                new_cm_id: selectedId,
                              });
                            }}
                          >
                            <option value="">
                              {strings.selectClosingManager}
                            </option>
                            {cmData.map((cm) => (
                              <option key={cm._id} value={cm._id}>
                                {cm.user_name}
                              </option>
                            ))}
                          </select>
                        </div>
                      </div>
                    </div>
                  )}

                  {Cmteam && (
                    <div className="row">
                      <div className="col-md-8">
                        <div className="form-check mb-3">
                          <input
                            type="checkbox"
                            className="form-check-input"
                            id="housingManagerCheckbox"
                            checked={form.isSousingManagerLead}
                            onChange={(e) => {
                              const isChecked = e.target.checked;

                              // Reset other fields only when checkbox is unchecked
                              if (!isChecked) {
                                setSelectedRoleId(res.data.role_id);
                                setForm({
                                  ...form,
                                  isSousingManagerLead: false,
                                  lead_source: "",
                                  referrel_partner: "",
                                  for_sm_id: null,
                                });
                              } else {
                                setSelectedRoleId(SourcingManager);
                                setForm({
                                  ...form,
                                  isSousingManagerLead: true,
                                  lead_source: "",
                                  for_sm_id: "",
                                  // property_id: form.property_id || "",
                                  referrel_partner: "",
                                });
                                getPropertyBasedSMRoleDetails(form.property_id);
                              }
                            }}
                            // disabled={!!leadId}
                          />
                          <label
                            className="form-check-label"
                            htmlFor="housingManagerCheckbox"
                          >
                            {strings.leadForSoursingManager}
                          </label>
                        </div>
                      </div>
                    </div>
                  )}

                  {form.isSousingManagerLead ? (
                    <div>
                      {leadId ? (
                        <div className="row ">
                          <div className="col-md-8 ">
                            <div className="mb-3">
                              <label htmlFor="exampleFormControlFirstName">
                                {strings.propertyname}
                                <span className="required-field"></span>
                              </label>
                              <input
                                className="form-control"
                                id="exampleFormControlFirstName"
                                type="text"
                                name="property_title"
                                value={form.property_title}
                                readOnly
                                placeholder={strings.propertyname}
                                onChange={handleInputField}
                              />
                            </div>
                          </div>
                        </div>
                      ) : (
                        <div className="row ">
                          <div className="col-md-8 ">
                            <div className="mb-3">
                              <label htmlFor="exampleFormControlFirstName">
                                {strings.propertyname}
                                <span className="required-field"></span>
                              </label>
                              <select
                                className="form-control digits"
                                id="formcontrol-select1"
                                name="property_id"
                                value={form.property_id}
                                onFocus={() =>
                                  form?.mobile?.length === 10
                                    ? null
                                    : errorToast(strings.mobileErr)
                                }
                                onChange={(e) => {
                                  var index =
                                    e.nativeEvent.target.selectedIndex;
                                  var property_title =
                                    e.nativeEvent.target[index].text;
                                  const nextFormState = {
                                    ...form,
                                    property_id: e.target.value,
                                    property_title: property_title,
                                  };
                                  setForm(nextFormState);
                                  checkMobileExistWithSameProperty(
                                    e.target.value
                                  );
                                  getPropertyBasedSMRoleDetails(e.target.value);
                                }}
                              >
                                <option defaultValue={null}>
                                  {strings.selectProp}
                                </option>
                                {form?.mobile?.length === 10
                                  ? Cmteam ||
                                    ((mixTeam || SMteam) &&
                                      form.lead_source !==
                                        CONST_IDS?.cp_lead_source_id)
                                    ? sourcingPropertyList.map(
                                        (item, index) => (
                                          <option
                                            key={index}
                                            value={item.property_id}
                                          >
                                            {item.property_title}
                                          </option>
                                        )
                                      )
                                    : allProperty &&
                                      allProperty.map((item, index) => (
                                        <option
                                          key={index}
                                          value={item.property_id}
                                        >
                                          {item.property_title}
                                        </option>
                                      ))
                                  : emptyArray.map((item, index) => (
                                      <option
                                        key={index}
                                        value={item.property_id}
                                      >
                                        {item.property_title}
                                      </option>
                                    ))}
                              </select>
                            </div>
                          </div>
                        </div>
                      )}

                      <div className="row">
                        <div className="col-md-8">
                          <div className="mb-3">
                            <label className="form-label fw-bold">
                              {strings.selectSM_Manager}
                              <span className="required-field"></span>
                            </label>
                            <select
                              className="form-control"
                              name="sourcing_manager_id"
                              value={form.for_sm_id}
                              onChange={(e) => {
                                const selectedId = e.target.value;
                                const selectedSM = smData.find(
                                  (sm) => sm._id === selectedId
                                );
                                const sm_id = selectedSM?._id || null;

                                setSelectedSMRoleId(sm_id);
                                getSmRolesUnderCpData(sm_id);
                                setForm({
                                  ...form,
                                  for_sm_id: selectedId,
                                });
                              }}
                            >
                              <option value="">
                                {strings.selectSourcingManager}
                              </option>
                              {smData.map((sm) => (
                                <option key={sm._id} value={sm._id}>
                                  {sm.user_name}
                                </option>
                              ))}
                            </select>
                            {formVaild?.for_sm_id && (
                              <span style={{ color: "red" }}>
                                {formVaild?.for_sm_id}
                              </span>
                            )}
                          </div>
                        </div>
                      </div>

                      {/* JUSTO-64: Lead source as radio (CP / Referral Partner) when Lead for SM selected and two options. */}
                      {form.for_sm_id && (
                        <div className="row">
                          <div className="col-md-8">
                            <div className="mb-3">
                              <label htmlFor="exampleFormControlLastName">
                                {strings.leadSource}
                                <span className="required-field"></span>
                              </label>
                              {(form.for_sm_id || form.isSousingManagerLead) &&
                              leadSourceType &&
                              leadSourceType.length === 2 ? (
                                <div className="d-flex flex-wrap" style={{ gap: "1rem" }}>
                                  {leadSourceType.map((item) => (
                                    <label
                                      key={item._id}
                                      className="d-flex align-items-center cursor-pointer"
                                      style={{ gap: "0.5rem" }}
                                    >
                                      <input
                                        type="radio"
                                        name="lead_source"
                                        value={item._id}
                                        checked={form.lead_source === item._id}
                                        onChange={(e) =>
                                          handleInputField2({
                                            target: {
                                              name: "lead_source",
                                              value: e.target.value,
                                            },
                                          })
                                        }
                                      />
                                      {item.title}
                                    </label>
                                  ))}
                                </div>
                              ) : (
                                <select
                                  className="form-control digits"
                                  id="formcontrol-select1"
                                  name="lead_source"
                                  value={form.lead_source}
                                  onChange={handleInputField2}
                                >
                                  <option value="">
                                    {strings.selectLeadSource}
                                  </option>
                                  {leadSourceType &&
                                    leadSourceType.map((item, index) => (
                                      <option key={index} value={item._id}>
                                        {item.title}
                                      </option>
                                    ))}
                                </select>
                              )}
                              {formVaild?.lead_source && (
                                <span style={{ color: "red" }}>
                                  {formVaild?.lead_source}
                                </span>
                              )}
                            </div>
                          </div>
                        </div>
                      )}

                      {/* JUSTO-64: CP lead type (Walk-in / Tele-calling) as radio buttons when lead source is Channel Partner. */}
                      {form.cp_type === "2" &&
                      form.lead_source === CONST_IDS?.cp_lead_source_id ? (
                        <>
                          <div className="row">
                            <div className="col-md-8">
                              <div className="mb-3">
                                <label htmlFor="cpLeadType">
                                  {strings.cpLeadType}
                                  <span className="required-field"></span>
                                </label>
                                <div className="d-flex flex-wrap" style={{ gap: "1rem" }}>
                                  <label className="d-flex align-items-center cursor-pointer" style={{ gap: "0.5rem" }}>
                                    <input
                                      type="radio"
                                      name="cp_lead_type"
                                      value="1"
                                      checked={form.cp_lead_type === "1"}
                                      onChange={handleLeadTypeChange}
                                    />
                                    {strings.walk_in}
                                  </label>
                                  <label className="d-flex align-items-center cursor-pointer" style={{ gap: "0.5rem" }}>
                                    <input
                                      type="radio"
                                      name="cp_lead_type"
                                      value="2"
                                      checked={form.cp_lead_type === "2"}
                                      onChange={handleLeadTypeChange}
                                    />
                                    {strings.teleCalling}
                                  </label>
                                </div>
                                {formVaild?.cp_lead_type && (
                                  <span style={{ color: "red" }}>
                                    {formVaild?.cp_lead_type}
                                  </span>
                                )}
                              </div>
                            </div>
                          </div>

                          {mixTeam || SMteam ? (
                            <div className="row">
                              <div className="col-md-8">
                                <div className="mb-3">
                                  <label htmlFor="exampleFormControlLastName">
                                    {strings.cpCompany}
                                    <span className="required-field"></span>
                                  </label>
                                  <select
                                    className="form-control digits"
                                    id="formcontrol-select1"
                                    name="cp_id"
                                    value={form.cp_id}
                                    onChange={handleInputField1}
                                    // onFocus={() => handleCompanyDropdownPress()}
                                    onBlur={() => callEmploy()}
                                    // isSearchable={true}
                                    // disabled={true}
                                  >
                                    <option value="">
                                      {strings.selectCpCompany}
                                    </option>
                                    {companyList &&
                                      companyList.map((item, index) => (
                                        <option key={index} value={item._id}>
                                          {item.agency_name}
                                        </option>
                                      ))}
                                  </select>
                                  {formVaild?.cp_id && (
                                    <span style={{ color: "red" }}>
                                      {formVaild?.cp_id}
                                    </span>
                                  )}
                                </div>
                              </div>
                            </div>
                          ) : (
                            <div className="row">
                              <div className="col-md-8">
                                <div className="mb-3">
                                  <label htmlFor="exampleFormControlLastName">
                                    {strings.cpCompany}
                                    <span className="required-field"></span>
                                  </label>
                                  <select
                                    className="form-control digits"
                                    id="formcontrol-select1"
                                    name="cp_id"
                                    value={form.cp_id}
                                    onChange={handleInputField1}
                                    // onFocus={() => handleCompanyDropdownPress()}
                                    onBlur={() => callEmploy()}
                                    // isSearchable={true}
                                  >
                                    <option value="">
                                      {strings.selectCpCompany}
                                    </option>
                                    {companyList &&
                                      companyList.map((item, index) => (
                                        <option key={index} value={item._id}>
                                          {item.agency_name}
                                        </option>
                                      ))}
                                  </select>
                                  {formVaild?.cp_id && (
                                    <span style={{ color: "red" }}>
                                      {formVaild?.cp_id}
                                    </span>
                                  )}
                                </div>
                              </div>
                            </div>
                          )}

                          {form?.cp_id !== "" ||
                          form.lead_source === CONST_IDS?.cp_lead_source_id ? (
                            <>
                              {mixTeam || SMteam ? (
                                <div className="row">
                                  <div className="col-md-8">
                                    <div className="mb-3">
                                      <label htmlFor="exampleFormControlLastName">
                                        {strings.companyEmployName}
                                        {/* <span className="required-field"></span> */}
                                      </label>
                                      <select
                                        className="form-control digits"
                                        id="formcontrol-select1"
                                        name="cp_emp_id"
                                        value={form.cp_emp_id}
                                        onChange={handleInputField}
                                        onFocus={() =>
                                          handleEmployeeDropdownPress()
                                        }
                                        // disabled={true}
                                      >
                                        <option value="">
                                          {strings.selectEmployeeName}
                                        </option>
                                        {employeeList &&
                                          employeeList.map((item, index) => (
                                            <option
                                              key={index}
                                              value={item.login_id}
                                            >
                                              {item.employee_name}
                                            </option>
                                          ))}
                                      </select>
                                      {formVaild?.cp_emp_id && (
                                        <span style={{ color: "red" }}>
                                          {formVaild?.cp_emp_id}
                                        </span>
                                      )}
                                    </div>
                                  </div>
                                </div>
                              ) : (
                                <div className="row">
                                  <div className="col-md-8">
                                    <div className="mb-3">
                                      <label htmlFor="exampleFormControlLastName">
                                        {strings.companyEmployName}
                                        {/* <span className="required-field"></span> */}
                                      </label>
                                      <select
                                        className="form-control digits"
                                        id="formcontrol-select1"
                                        name="cp_emp_id"
                                        value={form.cp_emp_id}
                                        onChange={handleInputField}
                                        onFocus={() =>
                                          handleEmployeeDropdownPress()
                                        }
                                      >
                                        <option value="">
                                          {strings.selectEmployeeName}
                                        </option>
                                        {employeeList &&
                                          employeeList.map((item, index) => (
                                            <option
                                              key={index}
                                              value={item.login_id}
                                            >
                                              {item.employee_name}
                                            </option>
                                          ))}
                                      </select>
                                      {formVaild?.cp_emp_id && (
                                        <span style={{ color: "red" }}>
                                          {formVaild?.cp_emp_id}
                                        </span>
                                      )}
                                    </div>
                                  </div>
                                </div>
                              )}
                            </>
                          ) : null}
                        </>
                      ) : null}
                      {form.lead_source === CONST_IDS?.ref_lead_source_id ||
                      form.lead_source === referralPartnerMaster ? (
                        <>
                          <div className="row">
                            <div className="col-md-8">
                              <div className="mb-3">
                                <label htmlFor="exampleInputMobileNo">
                                  {strings.referrerNumber}
                                  <span className="required-field"></span>
                                </label>
                                <input
                                  className="form-control"
                                  id="exampleInputMobileNo"
                                  readOnly={
                                    isCreated
                                      ? false
                                      : form?.lead_id
                                      ? true
                                      : false
                                  }
                                  type="text"
                                  maxLength={10}
                                  name="referrer_contact"
                                  value={
                                    leadId
                                      ? isCreated
                                        ? form?.referrer_contact
                                        : form?.referrer_contact
                                        ? hideMobileNumber(
                                            form?.referrer_contact
                                          )
                                        : ""
                                      : form?.referrer_contact
                                  }
                                  placeholder={strings.referrerNumber}
                                  onChange={handleInputField}
                                  autoComplete="off"
                                  onKeyPress={(event) => {
                                    if (/^[a-z]+$/.test(event.key)) {
                                      event.preventDefault();
                                    }
                                  }}
                                  onFocus={() => setVisitResponse({})}
                                />
                                {formVaild?.referrer_contact && (
                                  <span style={{ color: "red" }}>
                                    {formVaild?.referrer_contact}
                                  </span>
                                )}
                              </div>
                            </div>
                          </div>

                          {/* Display referrer name and email fields */}
                          <div className="row">
                            <div className="col-md-8">
                              <div className="mb-3">
                                <label htmlFor="referrerName">
                                  {strings.referrerName}
                                </label>
                                <input
                                  className="form-control"
                                  id="referrerName"
                                  type="text"
                                  name="referrer_name"
                                  value={form.referrer_name}
                                  placeholder={strings.referrerName}
                                  onChange={handleInputField}
                                  autoComplete="off"
                                />
                                {formVaild?.referrer_name && (
                                  <span style={{ color: "red" }}>
                                    {formVaild?.referrer_name}
                                  </span>
                                )}
                              </div>
                            </div>
                          </div>

                          <div className="row">
                            <div className="col-md-8">
                              <div className="mb-3">
                                <label htmlFor="referrerEmail">
                                  {strings.referrerEmail}
                                </label>
                                <input
                                  className="form-control"
                                  id="referrerEmail"
                                  type="email"
                                  name="referrer_email"
                                  value={form.referrer_email}
                                  placeholder={strings.referrerEmail}
                                  onChange={handleInputField}
                                  autoComplete="off"
                                />
                                {formVaild?.referrer_email && (
                                  <span style={{ color: "red" }}>
                                    {formVaild?.referrer_email}
                                  </span>
                                )}
                              </div>
                            </div>
                          </div>
                        </>
                      ) : null}
                    </div>
                  ) : (
                    <div>
                      {leadId ? (
                        <div className="row">
                          <div className="col-md-8">
                            <div className="mb-3">
                              <label htmlFor="exampleFormControlLastName">
                                {strings.leadSource}
                                <span className="required-field"></span>
                              </label>
                              {/* JUSTO-64: Lead source radio when Lead for SM selected and two options (CP / Referral Partner). */}
                              {(form.for_sm_id || form.isSousingManagerLead) &&
                              leadSourceType &&
                              leadSourceType.length === 2 ? (
                                <div className="d-flex flex-wrap" style={{ gap: "1rem" }}>
                                  {leadSourceType.map((item) => (
                                    <label
                                      key={item._id}
                                      className="d-flex align-items-center cursor-pointer"
                                      style={{ gap: "0.5rem" }}
                                    >
                                      <input
                                        type="radio"
                                        name="lead_source"
                                        value={item._id}
                                        checked={form.lead_source === item._id}
                                        onChange={(e) =>
                                          handleInputField({
                                            target: {
                                              name: "lead_source",
                                              value: e.target.value,
                                            },
                                          })
                                        }
                                      />
                                      {item.title}
                                    </label>
                                  ))}
                                </div>
                              ) : (
                                <select
                                  className="form-control digits"
                                  id="formcontrol-select1"
                                  name="lead_source"
                                  value={getLeadSource()}
                                  onChange={handleInputField}
                                >
                                  <option value="">
                                    {strings.selectLeadSource}
                                  </option>
                                  {leadSourceType &&
                                    leadSourceType.map((item, index) => (
                                      <option key={index} value={item._id}>
                                        {item.title}
                                      </option>
                                    ))}
                                </select>
                              )}
                              {formVaild?.lead_source && (
                                <span style={{ color: "red" }}>
                                  {formVaild?.lead_source}
                                </span>
                              )}
                            </div>
                          </div>
                        </div>
                      ) : (
                        <div className="row">
                          <div className="col-md-8">
                            <div className="mb-3">
                              <label htmlFor="exampleFormControlLastName">
                                {strings.leadSource}
                                <span className="required-field"></span>
                              </label>
                              {/* JUSTO-64: Lead source as radio (CP / Referral Partner) when Lead for SM and two options. */}
                              {(form.for_sm_id || form.isSousingManagerLead) &&
                              leadSourceType &&
                              leadSourceType.length === 2 ? (
                                <div className="d-flex flex-wrap" style={{ gap: "1rem" }}>
                                  {leadSourceType.map((item) => (
                                    <label
                                      key={item._id}
                                      className="d-flex align-items-center cursor-pointer"
                                      style={{ gap: "0.5rem" }}
                                    >
                                      <input
                                        type="radio"
                                        name="lead_source"
                                        value={item._id}
                                        checked={form.lead_source === item._id}
                                        onChange={(e) =>
                                          handleInputField({
                                            target: {
                                              name: "lead_source",
                                              value: e.target.value,
                                            },
                                          })
                                        }
                                      />
                                      {item.title}
                                    </label>
                                  ))}
                                </div>
                              ) : (
                                <select
                                  className="form-control digits"
                                  id="formcontrol-select1"
                                  name="lead_source"
                                  value={form.lead_source}
                                  onChange={handleInputField}
                                >
                                  <option value="">
                                    {strings.selectLeadSource}
                                  </option>
                                  {leadSourceType &&
                                    leadSourceType.map((item, index) => (
                                      <option key={index} value={item._id}>
                                        {item.title}
                                      </option>
                                    ))}
                                </select>
                              )}
                              {formVaild?.lead_source && (
                                <span style={{ color: "red" }}>
                                  {formVaild?.lead_source}
                                </span>
                              )}
                            </div>
                          </div>
                        </div>
                      )}

                      {form.cp_type === "2" &&
                      {/* JUSTO-64: CP lead type (Walk-in / Tele-calling) as radio in alternate layout. */}
                      (mixTeam || SMteam) &&
                      form.lead_source === CONST_IDS?.cp_lead_source_id ? (
                        <>
                          <div className="row">
                            <div className="col-md-8">
                              <div className="mb-3">
                                <label htmlFor="cpLeadType">
                                  {strings.cpLeadType}
                                  <span className="required-field"></span>
                                </label>
                                <div className="d-flex flex-wrap" style={{ gap: "1rem" }}>
                                  <label className="d-flex align-items-center cursor-pointer" style={{ gap: "0.5rem" }}>
                                    <input
                                      type="radio"
                                      name="cp_lead_type"
                                      value="1"
                                      checked={form.cp_lead_type === "1"}
                                      onChange={handleLeadTypeChange}
                                    />
                                    {strings.walk_in}
                                  </label>
                                  <label className="d-flex align-items-center cursor-pointer" style={{ gap: "0.5rem" }}>
                                    <input
                                      type="radio"
                                      name="cp_lead_type"
                                      value="2"
                                      checked={form.cp_lead_type === "2"}
                                      onChange={handleLeadTypeChange}
                                    />
                                    {strings.teleCalling}
                                  </label>
                                </div>
                                {formVaild?.cp_lead_type && (
                                  <span style={{ color: "red" }}>
                                    {formVaild?.cp_lead_type}
                                  </span>
                                )}
                              </div>
                            </div>
                          </div>
                          <div className="row">
                            <div className="col-md-8">
                              <div className="mb-3">
                                <label htmlFor="exampleFormControlLastName">
                                  {strings.cpCompany}
                                  <span className="required-field"></span>
                                </label>
                                <select
                                  className="form-control digits"
                                  id="formcontrol-select1"
                                  name="cp_id"
                                  value={form.cp_id}
                                  onChange={handleInputField3}
                                  // onFocus={() => handleCompanyDropdownPress()}
                                  onBlur={() => callEmploy()}
                                  // isSearchable={true}
                                >
                                  <option value="">
                                    {strings.selectCpCompany}
                                  </option>
                                  {companyList &&
                                    companyList.map((item, index) => (
                                      <option key={index} value={item._id}>
                                        {item.agency_name}
                                      </option>
                                    ))}
                                </select>
                                {formVaild?.cp_id && (
                                  <span style={{ color: "red" }}>
                                    {formVaild?.cp_id}
                                  </span>
                                )}
                              </div>
                            </div>
                          </div>
                          {form?.cp_id !== "" ||
                          ((mixTeam || SMteam) &&
                            form.lead_source ===
                              CONST_IDS?.cp_lead_source_id) ? (
                            <div className="row">
                              <div className="col-md-8">
                                <div className="mb-3">
                                  <label htmlFor="exampleFormControlLastName">
                                    {strings.companyEmployName}
                                    {/* <span className="required-field"></span> */}
                                  </label>
                                  <select
                                    className="form-control digits"
                                    id="formcontrol-select1"
                                    name="cp_emp_id"
                                    value={form.cp_emp_id}
                                    onChange={handleInputField}
                                    onFocus={() =>
                                      handleEmployeeDropdownPress()
                                    }
                                  >
                                    <option value="">
                                      {strings.selectEmployeeName}
                                    </option>
                                    {employeeList &&
                                      employeeList.map((item, index) => (
                                        <option
                                          key={index}
                                          value={item.login_id}
                                        >
                                          {item.employee_name}
                                        </option>
                                      ))}
                                  </select>
                                  {formVaild?.cp_emp_id && (
                                    <span style={{ color: "red" }}>
                                      {formVaild?.cp_emp_id}
                                    </span>
                                  )}
                                </div>
                              </div>
                            </div>
                          ) : null}
                        </>
                      ) : null}

                      {form.lead_source === CONST_IDS?.ref_lead_source_id ||
                      form.lead_source === referralPartnerMaster ? (
                        <>
                          <div className="row">
                            <div className="col-md-8">
                              <div className="mb-3">
                                <label htmlFor="exampleInputMobileNo">
                                  {strings.referrerNumber}
                                  <span className="required-field"></span>
                                </label>
                                <input
                                  className="form-control"
                                  id="exampleInputMobileNo"
                                  readOnly={
                                    isCreated
                                      ? false
                                      : form?.lead_id
                                      ? true
                                      : false
                                  }
                                  type="text"
                                  maxLength={10}
                                  name="referrer_contact"
                                  value={
                                    leadId
                                      ? isCreated
                                        ? form?.referrer_contact
                                        : form?.referrer_contact
                                        ? hideMobileNumber(
                                            form?.referrer_contact
                                          )
                                        : ""
                                      : form?.referrer_contact
                                  }
                                  placeholder={strings.referrerNumber}
                                  onChange={handleInputField}
                                  autoComplete="off"
                                  onKeyPress={(event) => {
                                    if (/^[a-z]+$/.test(event.key)) {
                                      event.preventDefault();
                                    }
                                  }}
                                  onFocus={() => setVisitResponse({})}
                                />
                                {formVaild?.referrer_contact && (
                                  <span style={{ color: "red" }}>
                                    {formVaild?.referrer_contact}
                                  </span>
                                )}
                              </div>
                            </div>
                          </div>
                          {/* Display referrer name and email fields */}
                          <div className="row">
                            <div className="col-md-8">
                              <div className="mb-3">
                                <label htmlFor="referrerName">
                                  {strings.referrerName}
                                </label>
                                <input
                                  className="form-control"
                                  id="referrerName"
                                  type="text"
                                  name="referrer_name"
                                  value={form.referrer_name}
                                  placeholder={strings.referrerName}
                                  onChange={handleInputField}
                                  autoComplete="off"
                                />
                                {formVaild?.referrer_name && (
                                  <span style={{ color: "red" }}>
                                    {formVaild?.referrer_name}
                                  </span>
                                )}
                              </div>
                            </div>
                          </div>
                          <div className="row">
                            <div className="col-md-8">
                              <div className="mb-3">
                                <label htmlFor="referrerEmail">
                                  {strings.referrerEmail}
                                </label>
                                <input
                                  className="form-control"
                                  id="referrerEmail"
                                  type="email"
                                  name="referrer_email"
                                  value={form.referrer_email}
                                  placeholder={strings.referrerEmail}
                                  onChange={handleInputField}
                                  autoComplete="off"
                                />
                                {formVaild?.referrer_email && (
                                  <span style={{ color: "red" }}>
                                    {formVaild?.referrer_email}
                                  </span>
                                )}
                              </div>
                            </div>
                          </div>
                        </>
                      ) : null}

                      {leadId && (
                        <div className="row ">
                          <div className="col-md-8 ">
                            <div className="mb-3">
                              <label htmlFor="exampleFormControlFirstName">
                                {strings.propertyname}
                                <span className="required-field"></span>
                              </label>
                              <input
                                className="form-control"
                                id="exampleFormControlFirstName"
                                type="text"
                                name="property_title"
                                value={form.property_title}
                                readOnly
                                placeholder={strings.propertyname}
                                onChange={handleInputField}
                              />
                            </div>
                          </div>
                        </div>
                      )}
                    </div>
                  )}

                  <div className="row">
                    <div className="col-12 col-md-8">
                      <div className="mb-3">
                        <label htmlFor="gender">
                          {strings.gender}{" "}
                          <span className="required-field"></span>
                        </label>
                        <div className="row">
                          {/* Male */}
                          <div className="col-6 col-sm-6 col-md-3 mb-2">
                            <div className="form-check">
                              <input
                                className="form-check-input"
                                type="radio"
                                name="gender"
                                id="radio_male"
                                value={1}
                                checked={Number(form.gender) === 1}
                                onChange={handleInputField}
                              />
                              <label
                                className="form-check-label"
                                htmlFor="radio_male"
                              >
                                {strings.male}
                              </label>
                            </div>
                          </div>

                          {/* Female */}
                          <div className="col-6 col-sm-6 col-md-3 mb-2">
                            <div className="form-check">
                              <input
                                className="form-check-input"
                                type="radio"
                                name="gender"
                                id="radio_female"
                                value={2}
                                checked={Number(form.gender) === 2}
                                onChange={handleInputField}
                              />
                              <label
                                className="form-check-label"
                                htmlFor="radio_female"
                              >
                                {strings.female}
                              </label>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-md-8">
                      <div className="mb-3">
                        <label htmlFor="exampleInputMobileNo">
                          {strings.whatsappNo}
                        </label>
                        <input
                          className="form-control"
                          id="exampleInputMobileNo"
                          type="text"
                          maxLength={10}
                          name="whatsapp_no"
                          value={form.whatsapp_no}
                          placeholder={strings.whatsappNo}
                          onChange={handleInputField}
                          autoComplete="off"
                          onKeyPress={(event) => {
                            if (/^[a-z]+$/.test(event.key)) {
                              event.preventDefault();
                            }
                          }}
                        />
                        {formVaild?.whatsapp_no && (
                          <span style={{ color: "red" }}>
                            {formVaild?.whatsapp_no}
                          </span>
                        )}
                      </div>
                    </div>
                  </div>

                  <div className="row pt-2">
                    <div className="col-md-8">
                      <div className="mb-3">
                        <label htmlFor="exampleInputMobileNo">
                          {strings.emailAddress}
                        </label>
                        <input
                          className="form-control"
                          id="exampleInputMobileNo"
                          autoComplete="off"
                          // readOnly={form.lead_id ? true : false}
                          type="email"
                          name="email"
                          value={form.email}
                          placeholder={strings.emailaddress}
                          onChange={handleInputField}
                        />
                        {formVaild?.email && (
                          <span style={{ color: "red" }}>
                            {formVaild?.email}
                          </span>
                        )}
                      </div>
                    </div>
                  </div>

                  <div className="row pt-2">
                    <div className="col-md-8">
                      <div className="mb-3">
                        <label htmlFor="exampleInputMobileNo">
                          {strings.residentLocation}
                        </label>
                        <input
                          className="form-control"
                          id="exampleInputMobileNo"
                          placeholder={strings.location}
                          value={form.location}
                          onChange={handleInputField}
                          // onSelect={onSelect}
                          name="location"
                          type="text"
                          autoComplete="off"
                        />
                      </div>
                    </div>
                  </div>

                  <div className="row pt-2">
                    <div className="col-md-8">
                      <div className="mb-3">
                        <label htmlFor="exampleFormControlInput1">
                          {strings.workLocation}
                        </label>
                        <input
                          className="form-control"
                          id="exampleFormControlInput1"
                          type="text"
                          name="office_address"
                          value={form.office_address}
                          placeholder={strings.workLocation}
                          onChange={handleInputField}
                          autoComplete="off"
                        />
                      </div>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-md-8">
                      <div className="mb-3">
                        <label htmlFor="exampleFormControlLastName">
                          {strings.ethniCity}
                        </label>
                        <select
                          className="form-control digits"
                          id="formcontrol-select1"
                          name="ethnicity_id"
                          value={form.ethnicity_id}
                          onChange={(e) => {
                            var index = e.target.selectedIndex;
                            var ethnicity = e.target[index].text;
                            const nextFormState = {
                              ...form,
                              ethnicity_id: e.target.value,
                              ethnicity: ethnicity,
                            };
                            setForm(nextFormState);
                          }}
                        >
                          {form.ethnicity_id ? (
                            <></>
                          ) : (
                            <option value={""}>
                              {strings.selectEthnicity}
                            </option>
                          )}

                          {ethnicityList.length > 0 ? (
                            ethnicityList.map((item, i) => (
                              <option key={i} value={item._id}>
                                {item.title}
                              </option>
                            ))
                          ) : (
                            <option></option>
                          )}
                        </select>
                      </div>
                    </div>
                  </div>

                  <div className="row ">
                    <div className="col-md-8 ">
                      <div className="mb-3">
                        <label htmlFor="exampleFormControlFirstName">
                          {strings.maritalStatus}
                        </label>
                        <select
                          className="form-control digits"
                          id="formcontrol-select1"
                          name="marital_status"
                          value={form.marital_status}
                          onChange={handleInputField}
                        >
                          <option defaultValue={null}>
                            {strings.selectMaritalStatus}
                          </option>
                          <option value={2}>{strings.married}</option>
                          <option value={1}>{strings.unmarried}</option>
                        </select>
                      </div>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-12 col-md-8">
                      <div className="mb-3">
                        <label htmlFor="visit_with">
                          {strings.visitingWith}
                        </label>
                        <div className="row">
                          {/* Family */}
                          <div className="col-6 col-sm-6 col-md-3 mb-2">
                            <div className="form-check">
                              <input
                                className="form-check-input"
                                type="radio"
                                name="visit_with"
                                id="radio_family"
                                value="family"
                                checked={form.visit_with === "family"}
                                onChange={handleInputField}
                              />
                              <label
                                className="form-check-label"
                                htmlFor="radio_family"
                              >
                                {strings.family}
                              </label>
                            </div>
                          </div>

                          {/* Couple */}
                          <div className="col-6 col-sm-6 col-md-3 mb-2">
                            <div className="form-check">
                              <input
                                className="form-check-input"
                                type="radio"
                                name="visit_with"
                                id="radio_couple"
                                value="couple"
                                checked={form.visit_with === "couple"}
                                onChange={handleInputField}
                              />
                              <label
                                className="form-check-label"
                                htmlFor="radio_couple"
                              >
                                {strings.couple}
                              </label>
                            </div>
                          </div>

                          {/* Friend */}
                          <div className="col-6 col-sm-6 col-md-3 mb-2">
                            <div className="form-check">
                              <input
                                className="form-check-input"
                                type="radio"
                                name="visit_with"
                                id="radio_friend"
                                value="friend"
                                checked={form.visit_with === "friend"}
                                onChange={handleInputField}
                              />
                              <label
                                className="form-check-label"
                                htmlFor="radio_friend"
                              >
                                {strings.friend}
                              </label>
                            </div>
                          </div>

                          {/* Single */}
                          <div className="col-6 col-sm-6 col-md-3 mb-2">
                            <div className="form-check">
                              <input
                                className="form-check-input"
                                type="radio"
                                name="visit_with"
                                id="radio_single"
                                value="single"
                                checked={form.visit_with === "single"}
                                onChange={handleInputField}
                              />
                              <label
                                className="form-check-label"
                                htmlFor="radio_single"
                              >
                                {strings.single}
                              </label>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="row ">
                    <div className="col-md-8 ">
                      <div className="mb-3">
                        <label htmlFor="exampleFormControlFirstName">
                          {strings.currentStay}
                        </label>
                        <select
                          className="form-control digits"
                          id="formcontrol-select1"
                          name="current_stay"
                          value={form.current_stay}
                          onChange={handleInputField}
                        >
                          <option defaultValue={null}>
                            {strings.currentStayselect}
                          </option>
                          <option value={"Rented"}>{strings.rented}</option>
                          <option value={"Owned"}>{strings.owned}</option>
                        </select>
                      </div>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-md-8">
                      <div className="mb-3">
                        <label htmlFor="occupationSelect">
                          {strings.occupation}
                        </label>
                        <select
                          id="occupationSelect"
                          name="occupation"
                          className="form-control"
                          value={form.occupation}
                          onChange={handleInputField}
                        >
                          <option value="">-- Select Occupation --</option>
                          <option value="salaried">{strings.salaried}</option>
                          <option value="business">{strings.business}</option>
                          <option value="professional">
                            {strings.professional}
                          </option>
                          <option value="retired">{strings.retired}</option>
                          <option value="home maker">
                            {strings.homeMaker}
                          </option>
                          <option value="self employee">
                            {strings.selfEmployed}
                          </option>
                          <option value="others">{strings.others}</option>
                        </select>
                      </div>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-12 col-md-8">
                      <div className="mb-3">
                        <label htmlFor="qualified">{strings.leadStatus}</label>
                        <div className="row">
                          {/* Qualified (True) */}
                          <div className="col-6 col-sm-6 col-md-3 mb-2">
                            <div className="form-check">
                              <input
                                className="form-check-input"
                                type="radio"
                                name="qualified"
                                id="radio_qualified_true"
                                value="true"
                                checked={form.qualified === "true"}
                                onChange={handleInputField}
                              />
                              <label
                                className="form-check-label"
                                htmlFor="radio_qualified_true"
                              >
                                {strings.qualified}
                              </label>
                            </div>
                          </div>

                          {/* Unqualified (False) */}
                          <div className="col-6 col-sm-6 col-md-3 mb-2">
                            <div className="form-check">
                              <input
                                className="form-check-input"
                                type="radio"
                                name="qualified"
                                id="radio_qualified_false"
                                value="false"
                                checked={form.qualified === "false"}
                                onChange={handleInputField}
                              />
                              <label
                                className="form-check-label"
                                htmlFor="radio_qualified_false"
                              >
                                {strings.unQualified}
                              </label>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-12 col-md-8">
                      <div className="mb-3">
                        <label htmlFor="visit_with">
                          {strings.leadPriority}
                        </label>
                        <div className="row">
                          {/* hot */}
                          <div className="col-6 col-sm-6 col-md-3 mb-2">
                            <div className="form-check">
                              <input
                                className="form-check-input"
                                type="radio"
                                name="lead_priority"
                                id="radio_hot"
                                value="hot"
                                checked={form.lead_priority === "hot"}
                                onChange={handleInputField}
                              />
                              <label
                                className="form-check-label"
                                htmlFor="radio_hot"
                              >
                                {strings.hot}
                              </label>
                            </div>
                          </div>

                          {/* warm */}
                          <div className="col-6 col-sm-6 col-md-3 mb-2">
                            <div className="form-check">
                              <input
                                className="form-check-input"
                                type="radio"
                                name="lead_priority"
                                id="radio_warm"
                                value="warm"
                                checked={form.lead_priority === "warm"}
                                onChange={handleInputField}
                              />
                              <label
                                className="form-check-label"
                                htmlFor="radio_warm"
                              >
                                {strings.warm}
                              </label>
                            </div>
                          </div>

                          {/* cold */}
                          <div className="col-6 col-sm-6 col-md-3 mb-2">
                            <div className="form-check">
                              <input
                                className="form-check-input"
                                type="radio"
                                name="lead_priority"
                                id="radio_cold"
                                value="cold"
                                checked={form.lead_priority === "cold"}
                                onChange={handleInputField}
                              />
                              <label
                                className="form-check-label"
                                htmlFor="radio_cold"
                              >
                                {strings.cold}
                              </label>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-12 d-flex justify-content-end">
                    <div className="card-footer">
                      <button
                        className="btn btn-color"
                        type="button"
                        onClick={() => handleNext()}
                      >
                        {strings.next}
                      </button>
                    </div>
                  </div>
                  {!isEmpty(formVaild) && (
                    <div className="col-md-12 float-right">
                      <span
                        style={{
                          color: "red",
                          float: "right",
                          // padding: "5px 15px 25px 5px",
                        }}
                      >
                        {strings.fieldRequired}
                      </span>
                    </div>
                  )}
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      {visitModule && <div className="modal-backdrop fade show"></div>}
    </div>
  );
};
export default EditVisitorNextDraft;
